import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LeadFormService {
  constructor(private http: HttpClient) {}

  createLead(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/public/v2/leads`,
      data
    );
  }

  updateLead(data: any, leadId: string): Observable<any> {
    return this.http.put<any>(
      `${environment.apiUrl}/api/public/v2/leads/${leadId}`,
      data
    ); // Corrected URL
  }

  createDealLead(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/public/package-deals-lead`,
      data
    );
  }
}
